export const ATTACHMENT_FILTER_TYPE = Object.freeze({
  extension: "extension",
  fileType: "filetype",
  fileName: "filename",
  mimeType: "mimetype",
  ppa: "ppa",
});

export default {};
